export const LOGIN_PROBLEM_PATH = "/inloggningsproblem";

const LOGIN_URL = "/oauth2/authorization/google";
const ATTEMPT_KEY = "loginAttempt";
const RETURN_PATH_KEY = "postLoginPath";
const LOOP_WINDOW_MS = 30_000;

const storage = {
  get(key) {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // Lagringen kan vara blockerad; inloggningen fungerar ändå, bara utan loopskydd/återgång
    }
  },
  remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // se ovan
    }
  },
};

export function redirectToLogin() {
  if (window.location.pathname === LOGIN_PROBLEM_PATH) return;

  // Kommer vi tillbaka från Google och fortfarande är utloggade är något trasigt
  // (cookie/session). Bryt loopen istället för att skicka iväg användaren igen.
  const lastAttempt = Number(storage.get(ATTEMPT_KEY) || 0);
  if (Date.now() - lastAttempt < LOOP_WINDOW_MS) {
    window.location.replace(LOGIN_PROBLEM_PATH);
    return;
  }

  storage.set(ATTEMPT_KEY, String(Date.now()));
  storage.set(
    RETURN_PATH_KEY,
    window.location.pathname + window.location.search + window.location.hash
  );
  window.location.href = LOGIN_URL;
}

export function retryLogin() {
  storage.remove(ATTEMPT_KEY);
  window.location.href = LOGIN_URL;
}

// Sidan användaren var på innan inloggningen, eller null. Backend skickar alltid till "/".
export function consumeReturnPath() {
  const path = storage.get(RETURN_PATH_KEY);
  storage.remove(RETURN_PATH_KEY);
  if (!path || !path.startsWith("/") || path.startsWith("//") || path.startsWith(LOGIN_PROBLEM_PATH)) {
    return null;
  }
  return path;
}

export function installLoginHandler() {
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);
    const url = new URL(input instanceof Request ? input.url : String(input), window.location.origin);
    if (url.origin === window.location.origin && url.pathname.startsWith("/api/")) {
      if (response.status === 401) {
        redirectToLogin();
      } else if (response.ok) {
        storage.remove(ATTEMPT_KEY);
      }
    }
    return response;
  };
}
